export const BANK_ACCOUNT_REQUEST = 'bankAccountRequest';
export const BANK_ACCOUNT_LOADING = 'bankAccountLoading';
export const BANK_ACCOUNT_ERROR = 'bankAccountError';
export const POST_BANK_ACCOUNT = 'postBankAccount';
export const BANK_ACCOUNT_SUCCESS = 'bankAccountSuccess';
export const DOCUMENTS_REQUEST = 'documentsRequest';
export const PRINT_TWO_COPIES_REQUEST = 'printTwoCopiesRequest';
export const DOCUMENTS_LOADING = 'documentsLoading';
export const DOCUMENTS_ERROR = 'documentsError';
export const DOCUMENTS_SUCCESS = 'documentsSuccess';
export const DOCUMENT_ITEM_REQUEST = 'documentItemRequest';
export const DOCUMENT_ITEM_SUCCESS = 'documentItemSuccess';
export const PRINT_COPIES_SUCCESS = 'printCopiesSuccess';
export const POST_FILING_DECISION = 'postFilingDecision';
export const POST_FILING_DECISION_LOADING = 'postFilingDecisionLoading';
export const POST_FILING_DECISION_SUCCESS = 'postFilingDecisionSuccess';
export const POST_FILING_DECISION_ERROR = 'postFilingDecisionError';
export const SET_FILING_DECISION = 'setFilingDecision';
export const CLOSE_APP = 'closeApp';
export const CLOSE_APP_SUCCESS = 'closeAppSuccess';
export const CLOSE_APP_LOADING = 'closeAppLoading';
export const CLOSE_APP_ERROR = 'closeAppError';
export const POST_PROOF_FILE = 'postProofFile';
export const POST_PROOF_FILE_SUCCESS = 'postProofFileSuccess';
export const FETCH_PROOF_FILES = 'fetchProofFiles';
export const FETCH_PROOF_FILES_SUCCESS = 'fetchProofFilesSuccess';
export const DELETE_PROOF_FILE = 'deleteProofFile';
export const DELETE_PROOF_FILE_SUCCESS = 'deleteProofFileSuccess';
export const PROOF_FILES_LOADING = 'proofFilesLoading';
export const PROOF_FILES_ERROR = 'proofFilesError';
export const DOWNLOAD_PROOF_FILE = 'downloadProofFile';
export const UNLOCK_SECTIONS = 'unlockSections';
export const SET_BACK_TO_DECISION_PERMISSION = 'setBackToDecisionPermission';
